if (!customElements.get('flexible-shop-carousel')) {
  class FlexibleShopCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fshop-track]');
      this.previousButton = this.querySelector('[data-fshop-prev]');
      this.nextButton = this.querySelector('[data-fshop-next]');
      if (!this.track || !this.previousButton || !this.nextButton) return;

      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onScroll = () => this.update();
      this.previousButton.addEventListener('click', this.onPrevious);
      this.nextButton.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    move(direction) {
      const item = this.track.querySelector('.fshop-card, .fshop-step');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * .8;
      this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    }

    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      this.previousButton.disabled = position < 2;
      this.nextButton.disabled = position > max - 2;
      this.toggleAttribute('data-overflow', max > 2);
    }
  }

  customElements.define('flexible-shop-carousel', FlexibleShopCarousel);
}
